import addfriendicon from '../../assets/iconos/add-contact.svg'
import ProfilePic from '../../assets/iconos/usuario.png'
import Search from './Search.jsx';
import ContactList from './ContactList.jsx';
import { useState } from 'react';


export default function Contacts (props){

    const [chatFrame, setChatFrame] = useState(<ContactList setContact={props.setContact}/>);


    return(
        <div className='contacts-layout'>
            <div className='contact-options topborder '>
                <button onClick={e => setChatFrame(<ContactList setContact={props.setContact}/>)} className="green-btn sethoverdark setpointer">Contactos</button>
                <button onClick={e => setChatFrame(<Search />)} className="green-btn sethoverdark setpointer">Solicitudes</button>
            </div>
            <div className='contact- topborder'>
                {chatFrame}
            </div>
        </div>
    );
}